import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';
import SafeIcon from '../common/SafeIcon';

export default function About() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.about;

  if (!data.about) return null;

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="lg:col-span-2">
            <p className="text-xl text-slate-600 leading-relaxed font-light whitespace-pre-line max-w-3xl">
              {data.about}
            </p>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="bg-accent/5 p-6 rounded-2xl border border-accent/10">
            <h3 className="text-sm font-bold text-accent uppercase tracking-widest mb-4 flex items-center gap-2">
              <SafeIcon name="Award" className="w-4 h-4" /> {language === 'de' ? 'Zertifikate' : 'Certificates'}
            </h3>
            <ul className="space-y-3">
              {data.certificates_list.map((cert, idx) => (
                <li key={idx} className="text-xs font-medium text-slate-700 leading-snug">
                  • {cert}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}